// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import { objKeySort, genSign, toshowis } from "./assets/js/common.js";
import "./assets/css/style.css";
import "./assets/css/animate.min.css";
import { addCookie, getCookie, delCookie } from "./assets/js/cookie.js";
import axios from "axios";
import md5 from "js-md5";
import store from "./store";
import clickoutside from "./clickoutside/index.js";
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);
// import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$md5 = md5;

Vue.prototype.axios = axios;

Vue.prototype.$cookieStore = {
  addCookie,
  getCookie,
  delCookie,
};
Vue.prototype.$common = {
  objKeySort,
  genSign,
  toshowis,
};

Vue.config.productionTip = false;
/* eslint-disable no-new */
Vue.directive("clickoutside", clickoutside);
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>",
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/main.js